import styled from 'styled-components'

export const CtaContainer = styled.div`
  margin: 2rem auto 5rem;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  gap: 3rem;

  @media (min-width: 768px) {
    margin: 7rem auto;
    flex-direction: row;
    justify-content: center;
  }
`
